import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { UserService } from '../services/user.service';

/**
 * Restores session when navigation coming from maxperx
 */
@Injectable()
export class MaxPerxSessionGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const cacheKey = route.queryParamMap.get('cacheKey');
        return !cacheKey || this._userService.restoreSession(cacheKey);
    }
}
